import { Box } from '@mui/material'
import { useCurrentUser } from '../../../hooks/contexts/currentUserContext'
import TextParagraph from '../../../assets/components/TextParagraph'
import ActivateAccount from '../../ActivateAccount'
import { Instrument } from '../../../utils/types'
import Text from '../../../assets/components/Text'
import { usePostMqttResetNetwork } from '../../../mqtt/mqttHandlerContext'
import BasicButton from '../../../assets/components/BasicButton'
import FlashOnIcon from '@mui/icons-material/FlashOn'
import { useConnectedInstruments } from '../../../hooks/contexts/connectedInstrumentsContext'

import { useContext } from 'react'
import { PolyglotContext } from '../../../polyglot/polyGlotContext'

const sortOnType = (a: Instrument, b: Instrument) => {
    if (a.type < b.type) {
        return -1
    }
    if (a.type > b.type) {
        return 1
    }
    return 0
}

const License = () => {
    const { polyglot } = useContext(PolyglotContext)

    const currentUser = useCurrentUser()
    const connectedInstruments = useConnectedInstruments()
    const resetCurrentNetwork = usePostMqttResetNetwork()
    const alias = currentUser?.customer?.alias as string
    const instruments = currentUser?.customer?.instruments?.sort(sortOnType) as Instrument[]

    function isConnected(deviceId: string) {
        return connectedInstruments.some((instrument: Instrument) => instrument.deviceId === deviceId)
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '20px' }}>
            {currentUser?.customer ? (
                <>
                    <TextParagraph heading={polyglot.t('settings.license.headingOwner')} body={alias} />

                    {/* <TextParagraph heading={polyglot.t("settings.license.headingPaymentPlan")} body={paymentPlan && PaymentPlans[paymentPlan]} /> */}

                    {instruments ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '10px' }}>
                            <TextParagraph heading={polyglot.t('settings.license.headingConnectedInstruments')} />
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'flex-start',
                                    gap: '3rem',
                                    flexWrap: 'wrap'
                                }}
                            >
                                {instruments.map(
                                    (instrument: Instrument) =>
                                        instrument.serialNr && (
                                            <Box key={instrument.deviceId} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
                                                <Text>{instrument.serialNr}</Text>
                                                {isConnected(instrument.deviceId) && (
                                                    <>
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
                                                            <Box>
                                                                <FlashOnIcon sx={{ color: 'green' }} />
                                                                {polyglot.t('settings.license.boxActive')}
                                                            </Box>
                                                            <BasicButton
                                                                title={polyglot.t('settings.license.resetWifiPasswordBtn')}
                                                                variant="contained"
                                                                onClick={() => {
                                                                    resetCurrentNetwork(instrument.deviceId)
                                                                }}
                                                            />
                                                        </Box>
                                                    </>
                                                )}
                                            </Box>
                                        )
                                )}
                            </Box>
                        </Box>
                    ) : (
                        <TextParagraph heading={polyglot.t('settings.license.headingConnectedInstruments')} body={polyglot.t('settings.license.bodyConnectedInstruments')} />
                    )}
                </>
            ) : (
                <ActivateAccount />
            )}
        </Box>
    )
}

export default License
